// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.perxis-auto-1_16_13-drawer {
  /* Typography */
  --perxis-auto-drawer-header-font-family-inner: var(
    --perxis-auto-drawer-header-font-family,
    var(--perxis-auto-root-typography-h4-font-family-inner)
  );
  --perxis-auto-drawer-header-font-weight-inner: var(
    --perxis-auto-drawer-header-font-weight,
    var(--perxis-auto-root-typography-h4-font-weight-inner)
  );
  --perxis-auto-drawer-header-font-size-inner: var(
    --perxis-auto-drawer-header-font-size,
    var(--perxis-auto-root-typography-h4-font-size-xxl-inner)
  );
  --perxis-auto-drawer-header-font-style-inner: var(--perxis-auto-drawer-header-font-style, normal);
  --perxis-auto-drawer-header-color-inner: var(
    --perxis-auto-drawer-header-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  --perxis-auto-drawer-body-font-family-inner: var(
    --perxis-auto-drawer-body-font-family,
    var(--perxis-auto-root-typography-small-font-family-inner)
  );
  --perxis-auto-drawer-body-font-size-inner: var(
    --perxis-auto-drawer-body-font-size,
    var(--perxis-auto-root-typography-small-font-size-xxl-inner)
  );
  --perxis-auto-drawer-body-font-weight-inner: var(
    --perxis-auto-drawer-body-font-weight,
    var(--perxis-auto-root-typography-small-font-weight-inner)
  );
  --perxis-auto-drawer-body-letter-spacing-inner: var(
    --perxis-auto-drawer-body-letter-spacing,
    var(--perxis-auto-root-typography-small-letter-spacing-inner)
  );
  --perxis-auto-drawer-body-line-height-inner: var(
    --perxis-auto-drawer-body-line-height,
    var(--perxis-auto-root-typography-small-line-height-xxl-inner)
  );
  --perxis-auto-drawer-body-text-transform-inner: var(
    --perxis-auto-drawer-body-text-transform,
    var(--perxis-auto-root-typography-small-text-transform-inner)
  );
  --perxis-auto-drawer-body-font-variant-numeric-inner: var(
    --perxis-auto-drawer-body-font-variant-numeric,
    var(--perxis-auto-root-typography-small-font-variant-numeric-inner)
  );
  --perxis-auto-drawer-body-color-inner: var(
    --perxis-auto-drawer-body-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  --perxis-auto-drawer-icon-color-inner: var(
    --perxis-auto-drawer-icon-color,
    var(--perxis-auto-root-typography-color-dark-inner)
  );
  /* End Typography */
  /* Colors */
  --perxis-auto-drawer-background-color-inner: var(
    --perxis-auto-drawer-background-color,
    var(--perxis-auto-root-first-color-inner)
  );
  --perxis-auto-drawer-border-color-inner: var(
    --perxis-auto-drawer-border-color,
    var(--perxis-auto-root-ninth-color-inner)
  );
  /* End Colors */
  /* Z-index */
  --perxis-auto-drawer-z-index-inner: var(--perxis-auto-drawer-z-index, 1010);
  /* End Z-index */
  /* Padding */
  --perxis-auto-drawer-header-padding-inner: var(
    --perxis-auto-drawer-header-padding,
    var(--perxis-auto-gap-vertical-sky-inner) 18px var(--perxis-auto-gap-vertical-sky-inner) 18px
  );
  --perxis-auto-drawer-body-padding-inner: var(
    --perxis-auto-drawer-body-padding,
    var(--perxis-auto-gap-vertical-green-inner) 18px var(--perxis-auto-gap-vertical-green-inner) 18px
  );
  /* End Padding */
  /* Sizes */
  --perxis-auto-drawer-width-xxl-inner: var(--perxis-auto-drawer-width-xxl, 667px);
  --perxis-auto-drawer-width-lg-inner: var(--perxis-auto-drawer-width-lg, 768px);
  --perxis-auto-drawer-width-md-inner: var(--perxis-auto-drawer-width-md, 577px);
  --perxis-auto-drawer-width-sm-inner: var(--perxis-auto-drawer-width-sm, 320px);
  /* End Sizes */
}
.perxis-auto-1_16_13-drawer.ant-5_17_0-drawer {
  font-family: var(--perxis-auto-drawer-body-font-family-inner);
  font-size: var(--perxis-auto-drawer-body-font-size-inner);
  font-variant-numeric: var(--perxis-auto-drawer-body-font-variant-numeric-inner);
  line-height: var(--perxis-auto-drawer-body-line-height-inner);
  text-transform: var(--perxis-auto-drawer-body-text-transform-inner);
  letter-spacing: var(--perxis-auto-drawer-body-letter-spacing-inner);
  z-index: var(--perxis-auto-drawer-z-index-inner);
}
.perxis-auto-1_16_13-drawer.ant-5_17_0-drawer.ant-5_17_0-drawer-left .ant-5_17_0-drawer-content-wrapper, .perxis-auto-1_16_13-drawer.ant-5_17_0-drawer.ant-5_17_0-drawer-right .ant-5_17_0-drawer-content-wrapper {
  width: var(--perxis-auto-drawer-width-xxl-inner) !important;
}
@media (max-width: 992px) {
  .perxis-auto-1_16_13-drawer.ant-5_17_0-drawer.ant-5_17_0-drawer-left .ant-5_17_0-drawer-content-wrapper, .perxis-auto-1_16_13-drawer.ant-5_17_0-drawer.ant-5_17_0-drawer-right .ant-5_17_0-drawer-content-wrapper {
    width: var(--perxis-auto-drawer-width-lg-inner) !important;
  }
}
@media (max-width: 768px) {
  .perxis-auto-1_16_13-drawer.ant-5_17_0-drawer.ant-5_17_0-drawer-left .ant-5_17_0-drawer-content-wrapper, .perxis-auto-1_16_13-drawer.ant-5_17_0-drawer.ant-5_17_0-drawer-right .ant-5_17_0-drawer-content-wrapper {
    width: var(--perxis-auto-drawer-width-md-inner) !important;
  }
}
@media (max-width: 576px) {
  .perxis-auto-1_16_13-drawer.ant-5_17_0-drawer.ant-5_17_0-drawer-left .ant-5_17_0-drawer-content-wrapper, .perxis-auto-1_16_13-drawer.ant-5_17_0-drawer.ant-5_17_0-drawer-right .ant-5_17_0-drawer-content-wrapper {
    width: var(--perxis-auto-drawer-width-sm-inner) !important;
  }
}
.perxis-auto-1_16_13-drawer.ant-5_17_0-drawer .ant-5_17_0-drawer-mask,
.perxis-auto-1_16_13-drawer.ant-5_17_0-drawer .ant-5_17_0-drawer-content-wrapper {
  z-index: var(--perxis-auto-drawer-z-index-inner);
}
.perxis-auto-1_16_13-drawer.ant-5_17_0-drawer .ant-5_17_0-drawer-content {
  background-color: var(--perxis-auto-drawer-background-color-inner);
}
.perxis-auto-1_16_13-drawer.ant-5_17_0-drawer .ant-5_17_0-drawer-header {
  padding: 0;
  border-bottom-color: var(--perxis-auto-drawer-border-color-inner);
  color: var(--perxis-auto-drawer-header-color-inner);
}
.perxis-auto-1_16_13-drawer.ant-5_17_0-drawer .ant-5_17_0-drawer-header .ant-5_17_0-drawer-header-title {
  justify-content: space-between;
  flex-direction: row-reverse;
  padding: var(--perxis-auto-drawer-header-padding-inner);
}
.perxis-auto-1_16_13-drawer.ant-5_17_0-drawer .ant-5_17_0-drawer-header .ant-5_17_0-drawer-header-title .ant-5_17_0-drawer-title {
  --perxis-auto-typography-h4-font-family: var(--perxis-auto-drawer-header-font-family-inner);
  --perxis-auto-typography-h4-font-weight: var(--perxis-auto-drawer-header-font-weight-inner);
  --perxis-auto-typography-h4-font-style: var(--perxis-auto-drawer-header-font-style-inner);
  --perxis-auto-typography-color-darkest: var(--perxis-auto-drawer-header-color-inner);
  font-style: var(--perxis-auto-drawer-header-font-style-inner);
  --perxis-auto-typography-h4-font-size-xxs: var(--perxis-auto-drawer-header-font-size-inner);
  --perxis-auto-typography-h4-font-size-xs: var(--perxis-auto-drawer-header-font-size-inner);
  --perxis-auto-typography-h4-font-size-sm: var(--perxis-auto-drawer-header-font-size-inner);
  --perxis-auto-typography-h4-font-size-md: var(--perxis-auto-drawer-header-font-size-inner);
  --perxis-auto-typography-h4-font-size-lg: var(--perxis-auto-drawer-header-font-size-inner);
  --perxis-auto-typography-h4-font-size-xl: var(--perxis-auto-drawer-header-font-size-inner);
  --perxis-auto-typography-h4-font-size-xxl: var(--perxis-auto-drawer-header-font-size-inner);
}
.perxis-auto-1_16_13-drawer.ant-5_17_0-drawer .ant-5_17_0-drawer-body {
  font-family: var(--perxis-auto-drawer-body-font-family-inner);
  font-size: var(--perxis-auto-drawer-body-font-size-inner);
  font-variant-numeric: var(--perxis-auto-drawer-body-font-variant-numeric-inner);
  line-height: var(--perxis-auto-drawer-body-line-height-inner);
  color: var(--perxis-auto-drawer-body-color-inner);
  padding: var(--perxis-auto-drawer-body-padding-inner);
}
.perxis-auto-1_16_13-drawer.ant-5_17_0-drawer .ant-5_17_0-drawer-close {
  color: var(--perxis-auto-drawer-icon-color-inner);
  margin: 0;
  padding: 0;
}
.perxis-auto-1_16_13-drawer.ant-5_17_0-drawer .ant-5_17_0-drawer-close svg {
  fill: var(--perxis-auto-drawer-icon-color-inner);
}
.perxis-auto-1_16_13-drawer.ant-5_17_0-drawer.perxis-auto-1_16_13-drawer--close-icon-small .ant-5_17_0-drawer-close svg {
  width: 16px;
  height: 16px;
  line-height: 16px;
}
.perxis-auto-1_16_13-drawer.ant-5_17_0-drawer.perxis-auto-1_16_13-drawer--close-icon-middle .ant-5_17_0-drawer-close svg {
  width: 24px;
  height: 24px;
  line-height: 24px;
}
.perxis-auto-1_16_13-drawer.ant-5_17_0-drawer.perxis-auto-1_16_13-drawer--close-icon-large .ant-5_17_0-drawer-close svg {
  width: 30px;
  height: 30px;
  line-height: 30px;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
